import React, { useEffect, useCallback, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation, Trans } from "react-i18next";
import { Button } from 'primereact/button'
import { Card } from 'primereact/card';
import { FileUpload } from 'primereact/fileupload';
import { OverlayPanel } from 'primereact/overlaypanel';
import column from '../../../assets/images/column.png'
import guide from '../../../assets/images/Guidelines POPUP.png'
import selector from '../../../assets/images/Format Selector.png'
import DefMembershipActions from '../../../Redux/actions/defMembership-actions'
import BusinessCustomersActions from "../../../Redux/transition/customers/business-customer.reducer";
import { CustomValidationMessage } from "../../../Components/CustomMessage";

const Upload = ({
    handleContinue,
    handleUpload,
    navigateToImportPage,
    state,
    setState,
    audienceName,
    showAudienceContext = true,
    importHeaderKey = "business_customers.import-header",
    importSubHeaderKey = "business_customers.import-header-two",
}) => {
    const { t } = useTranslation("common");
    const fileUploadRef = useRef(null);
    const [continueClicked, setContinueClicked] = useState(false)
    const op1 = useRef(null)
    const op2 = useRef(null)
    const dispatch = useDispatch();

    //redux states
    const defMembership = useSelector((state) => state.defMembership.defMembership);

    const getMembership = useCallback(() => { dispatch(DefMembershipActions.defMembershipRequest()) }, [dispatch]);
    const downloadSampleCsvFile = useCallback(() => dispatch(BusinessCustomersActions.downloadCsvRequest()), [dispatch]);

    useEffect(() => {
        if (!defMembership) {
            getMembership();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleUploadContinueBtn = () => {
        setContinueClicked(true);
        if (!state.file?.name) return;
        handleUpload();
        handleContinue();
    }

    function handleClear() {
        setState((state) => ({ ...state, file: {} }));
        fileUploadRef.current.clear();
    }

    const continueWithoutFile = !state.file?.name && continueClicked;

    return (
        <div>
            <Card className='main-upload-card'>
                <div className='grid'>
                    <div className='col-6 pl-4 pt-5'>
                        {!showAudienceContext ? (
                            <>
                                <p className='title-text mb-0'>{t("business_customers.enrich_import_title")}</p>
                                <p className='enrich-upload-subtitle mb-2'>{t("business_customers.enrich_import_header")}</p>
                                <p className='sub_text mb-3'>{t("business_customers.enrich_import_description")}</p>
                                <div className='guildline-tip'>
                                    <p className='alert1 mb-2'>{t("business_customers.enrich_guidelines_title")}</p>
                                    <p className='alert2 mb-2'>
                                        <Trans
                                            i18nKey="business_customers.enrich_guidelines_text1"
                                            components={{
                                                1: <strong className="point-one-black" />,
                                                2: <strong className="point-one-black" />,
                                            }}
                                        />
                                    </p>
                                    <p className='alert2 mb-2'>
                                        <Trans
                                            i18nKey="business_customers.enrich_guidelines_text2"
                                            components={{ 1: <strong className="red-italic" /> }}
                                        />
                                    </p>
                                    <p className='alert2 mb-0'>
                                        <Trans
                                            i18nKey="business_customers.enrich_guidelines_text3"
                                            components={{ 1: <span className="red-link" /> }}
                                        />
                                    </p>
                                </div>
                            </>
                        ) : (
                            <>
                                <p className='title-text mb-0'>{t(importHeaderKey)}</p>
                                <p className='sub-title mb-0'>{t(importSubHeaderKey)}</p>
                                {audienceName && (
                                    <div className="mt-3">
                                        <Trans
                                            i18nKey="business_customers.audience_title"
                                            values={{ value: audienceName }}
                                            components={{
                                                a: <span className="red-only" />,
                                            }}
                                        />
                                    </div>
                                )}
                            </>
                        )}

                        <div className='upload-area'>
                            <div className="">
                                <p className="select-tip">{t("business_customers.tip")}</p>
                            </div>
                            {((defMembership?.role === "OWNER") || (defMembership?.role === "ADMIN")) &&
                                (<div className="flex align-content-center mt-3">
                                    <FileUpload
                                        ref={fileUploadRef}
                                        mode="basic"
                                        name="demo[]"
                                        className="import-csv-upload align-content-end"
                                        onSelect={(e) => {
                                            setState((state) => ({ ...state, file: e.files[0] }));
                                        }}
                                        customUpload
                                        uploadHandler={handleUpload}
                                        accept=".csv"
                                        emptyTemplate={<p className="m-0"></p>}
                                    />
                                    {continueWithoutFile && <CustomValidationMessage
                                        className="file-name-required"
                                        severity="error"
                                        text={t("business_customers.file_required")}
                                    />}
                                    {state.file?.name && <i className="pi pi-trash ml-2 remove-file" onClick={handleClear} />}
                                </div>
                                )}
                            <p className="hint-text">{t("business_customers.hint")}</p>
                        </div>

                        <p className='sub_text mb-0 ' onClick={() => { downloadSampleCsvFile() }}>
                            <Trans i18nKey="business_customers.upload_text" components={{ 1: <strong className="download-csv" /> }} />
                        </p>

                        <div className="mt-1 mb-1">
                            <Trans i18nKey="business_customers.final_tip"
                                components={{
                                    1: <strong className="black-one" />,
                                    2: <strong className="red-only" />,
                                }}
                            />
                        </div>
                        <div className='pop-over-div'>
                            <i className="pi pi-info-circle info-icon mr-1 hint-style" onClick={(e) => { op1.current.toggle(e) }} >
                            </i> <p className='payment_token'>{t("business_customers.pop_over")}</p>

                            <OverlayPanel ref={op1} className="custom-overlay-panel">
                                <div className="">
                                    <div className='mb-3 mt-2'>
                                        <div className='instruction2-header mb-2'>{t("business_customers.pop_over_header")}</div>
                                        <div>
                                            <p className='instruction2 mb-2'>
                                                <Trans i18nKey="business_customers.pop_over_text1" components={{ bold: <strong /> }} />
                                            </p>
                                            <p className='instruction2 mb-2'>
                                                <Trans i18nKey="business_customers.pop_over_text2" components={{ bold: <strong /> }} />
                                            </p>
                                            <p className='instruction2 mb-2'>
                                                <Trans i18nKey="business_customers.pop_over_text3" components={{ bold: <strong /> }} />
                                            </p>
                                            <img src={column} alt="col" />
                                            <p className='instruction2 mb-2'>
                                                <Trans i18nKey="business_customers.pop_over_text4"
                                                    components={{ bold: <strong />, 1: <strong style={{ color: "#9747ff", fontSize: "12px" }} />, 2: <strong style={{ fontStyle: "italic" }} /> }} />
                                            </p>
                                            <img src={selector} alt="col" />
                                        </div>
                                    </div>

                                </div>
                            </OverlayPanel>

                            <OverlayPanel ref={op2} className="custom-overlay-panel-guide">
                                <div className="p-2">
                                    <img src={guide} alt="guide" />
                                </div>
                            </OverlayPanel>
                        </div>
                    </div>
                    <div className='col-6'>

                    </div>

                </div>
                <div id="upload-button">
                    <Button className='import_cancel_button' onClick={navigateToImportPage} >
                        {t("cancel")}
                    </Button>
                    <Button className='import_button steps-button py-2' onClick={handleUploadContinueBtn} >
                        {t("continue")}
                    </Button>
                </div>

            </Card>
        </div>
    )
}
export default Upload;